/**
 * 通用的展示+按钮界面
 */
import classNames from 'classnames';
import { Button } from 'rc-ui-lib';
import { Ref } from 'react';
import { nativeApi } from '../../utils/nativeApi';
import lessStyle from './index.module.less';

export type commonLayoutProps = {
  children: React.ReactNode;
  btnText: string;
  onClickBtn: () => void;
  btnDisable?: boolean;
  showBtn?: boolean;
  style?: React.CSSProperties;
  layoutRef?: Ref<HTMLDivElement>;
  btnCls?: string;
  btnPrefix?: React.ReactNode;
  subBtnText?: string;
  onClickSubBtn?: () => void;
  customBtn?: React.ReactNode;
  btnWrapperCls?: string;
};

function CommonLayout(props: commonLayoutProps) {
  const {
    children,
    btnText,
    onClickBtn,
    btnDisable,
    showBtn,
    style,
    layoutRef,
    btnCls,
    btnPrefix,
    subBtnText,
    onClickSubBtn,
    customBtn,
    btnWrapperCls,
  } = props;
  const isNew = nativeApi.isNewVersion;
  return (
    <div className={lessStyle.layout} style={style} ref={layoutRef}>
      {children}
      {showBtn && (
        <div>
          {btnPrefix}
          <div
            className={`${lessStyle.btn_wrapper} ${isNew ? 'isNew' : ''} ${btnWrapperCls || ''}`}
          >
            {customBtn || (
              <>
                <Button
                  className={`${classNames(lessStyle.btn, btnCls)} ${isNew ? 'isNew' : ''}`}
                  type="primary"
                  onClick={onClickBtn}
                  disabled={btnDisable}
                >
                  {btnText}
                </Button>
                {subBtnText ? (
                  <div onClick={onClickSubBtn} className={lessStyle.sub_btn}>
                    {subBtnText}
                  </div>
                ) : null}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

CommonLayout.defaultProps = {
  btnDisable: false,
  showBtn: true,
};

export default CommonLayout;
